import { COMPLIANCE_TYPES_CRUD_ACTION_CREATORS } from '../actions/compliance_types_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

// Proposed backend contract: /api/v1/{buyer|supplier}/compliance/types
// Buyer side has full CRUD; supplier side is read-only (types of connected buyers).
const complianceTypesRestCrudThunksForBuyer = new RestCrudThunks(
	'types',
	'compliance_type',
	'complianceType',
	'complianceTypes',
	COMPLIANCE_TYPES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	true,
	'compliance/'
);

const complianceTypesRestCrudThunksForSupplier = new RestCrudThunks(
	'types',
	'compliance_type',
	'complianceType',
	'complianceTypes',
	COMPLIANCE_TYPES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'compliance/'
);

export const complianceTypesRestCrudThunks = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? complianceTypesRestCrudThunksForSupplier
		: complianceTypesRestCrudThunksForBuyer;
